<h3>COMMITTEE</h3>

<h5> CHAIRS </h5>
<p>The Chairs of CIFRIS23 are:</p>
<ul>
	<li> Michele Ciampi (The University of Edinburgh - Scotland)</li>
	<li> Sihem Mesnager (University of Paris VIII - France)</li>
</ul>
<h5>PROGRAM COMMITTEE MEMBERS</h5>
<ul>
	<li> Christian Badertscher (Input Output - Switzerland)</li>
	<li> Charles Bouillaguet (Sorbonne University LIP6 Paris - France)</li>
	<li> Marco Calderini (University of Trento - Italy)</li>
	<li> Matteo Campanelli (Protocol Labs - Denmark)</li>
	<li> Claude Carlet (Univ. of Paris 8 - France and Univ. of Bergen - Norway)</li>
	<li> Ilaria Chillotti (Zama)</li>
	<li> Danilo Francati (Aarhus University - Denmark)</li>
	<li> Daniele Friolo ("Sapienza" University of Rome - Italy)</li>
	<li> Philippe Gaborit (University of Limoges - France)</li>
	<li> Delaram Kahrobaei (New York University - USA)</li>
	<li> Dimitris Karakostas (The University of Edinburgh - Scotland)</li>
	<li> Nian Li (Hubei University - China)</li>
	<li> Atul Mantri (Virginia Tech - USA)</li>
	<li> Gérard Memmi (Télécom Paris, Institut Polytechnique de Paris - France)</li>
	<li> Giacomo Micheli (University of South Florida - USA)</li>
	<li> Emmanuela Orsini (Bocconi University - Italy)</li>
	<li> Alberto Ravagnani (The Eindhoven University - The Netherlands)</li>
	<li> Divya Ravi (Aarhus University - Denmark)</li>
	<li> Santanu Sarkar (Indian Institute of Technology Madras - India)</li>
	<li> Luisa Siniscalchi (Danmarks Tekniske Universitet (DTU) - Denmark)</li>
	<li> Pantelimon Stanica (Naval Postgraduate School - USA)</li>
	<li> Hendrik Waldner (Max Planck Institute for Security and Privacy, Bochum - Germany)</li>
	<li> Thomas Zacharias (The University of Edinburgh - Scotland)</li>
</ul>